<template>
  <div class="row">
    <div class="col-xs-12">
      <Box>
        <div class="row bottom-xs">
          <div class="col-xs-4 col-lg-3">
            <BaseInput
              label="Søg efter navn"
              placeholder="Indtast søgeord"
              :value="searchTerm"
              @input="$emit('input-search', $event)"
            />
          </div>
          <div class="col-xs-5 col-lg-7">
            <BaseFormField label="Status">
              <BaseRadioButton
                :value="filterBy"
                name="filterby"
                store="all"
                @input="$emit('input-filter', $event)"
                label="Alle"
              />
              <BaseRadioButton
                :value="filterBy"
                @input="$emit('input-filter', $event)"
                name="filterby"
                store="active"
                label="Aktive"
              />
              <BaseRadioButton
                :value="filterBy"
                @input="$emit('input-filter', $event)"
                name="filterby"
                store="deleted"
                label="Slettet"
              />
            </BaseFormField>
          </div>
          <div
            class="col-xs-3 col-lg-2"
            v-if="buttonLabel"
          >
            <BaseButton
              full
              :label="buttonLabel"
              @click.prevent="goTo"
            />
          </div>
        </div>
      </Box>
    </div>
  </div>
</template>

<script>
import BaseInput from './BaseInput.vue';
import BaseButton from './BaseButton.vue';
import BaseRadioButton from './BaseRadioButton.vue';
import BaseFormField from './BaseFormField.vue';
import Box from './Box.vue';

export default {
    name: 'TableTopFilterAndSearch',
    components: {
        Box, BaseFormField, BaseRadioButton, BaseButton, BaseInput,
    },
    props: {
        buttonLabel: { type: String, required: true },
        buttonLink: { type: String, required: true },
        filterBy: { type: String, required: true },
        searchTerm: { type: String, required: true },
    },
    methods: {
        goTo() {
            this.$router.push({ name: this.buttonLink });
        },
    },
};
</script>
